import React from 'react';
import { Box } from '@mui/material';
import { SummarySheetGraphsCount } from '@/__generated__/graphql';
import { Bar, getCriticalityLevelColor } from '../shared/styles';

const BAR_OFFSET = 3;

const DCBarChart = ({ damageClassCounts }: { damageClassCounts: SummarySheetGraphsCount[] }) => {
  const totalCount =
    damageClassCounts
      .map((damageClass) => damageClass.count)
      .reduce((accumulator, current) => {
        return (accumulator ?? 0) + (current ?? 0);
      }, 0) ?? 0;

  const barData = damageClassCounts.map(({ key, count }) => ({
    name: key ?? '',
    value: count ?? 0,
    width: `calc(${((count ?? 0) / (totalCount ?? 0)) * 100}% + ${BAR_OFFSET}px)`,
    fill: getCriticalityLevelColor(key ?? ''),
  }));

  const getPreviousCumulativeWidth = (index: number) => {
    return (
      (damageClassCounts
        .slice(0, index)
        .map((previousEntry) => previousEntry.count)
        .reduce((accumulator, current) => {
          return (accumulator ?? 0) + (current ?? 0);
        }, 0) ?? 0) / totalCount
    );
  };

  return (
    <Box
      sx={{
        marginTop: '16px',
        height: '12px',
        width: `calc(100% - ${BAR_OFFSET}px)`,
        position: 'relative',
      }}
    >
      {barData.map((entry, index) => (
        <Bar
          key={index}
          background={entry.fill}
          width={entry.width}
          offset={getPreviousCumulativeWidth(index)}
        />
      ))}
    </Box>
  );
};

export default DCBarChart;
